import { render, staticRenderFns } from "./cl-photo-gallery.vue?vue&type=template&id=121cf7c9&"
import script from "./cl-photo-gallery.vue?vue&type=script&lang=ts&"
export * from "./cl-photo-gallery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports